import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./ArticleHeader.module.scss";
export const ArticleHeader: React.FC<{
  title: string;
  inngress?: string;
  published?: string;
}> = t0 => {
  const $ = _c(10);
  const {
    title,
    inngress,
    published
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div><h1>{title}</h1></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== inngress) {
    t2 = inngress ? <div>{inngress ? <p className="inngress">{inngress}</p> : null}</div> : null;
    $[2] = inngress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== published) {
    t3 = published ? <div>{published ? <span>{new Date(published).toLocaleDateString("no-NB")}</span> : null}</div> : null;
    $[4] = published;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <section className={style.articleheader} data-toc-id="header">{t1}{t2}{t3}</section>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};